// extracted by mini-css-extract-plugin
export default {"tagTreePopover":"TagTreePopover__tagTreePopover___dKyTT","tagsSearchInput":"TagTreePopover__tagsSearchInput___uWEs_"};